import Carousel from 'react-bootstrap/Carousel';

function PadestrianRollerCarousel() {
  return (
    <Carousel  indicators={false} className="goals-carousel concrete-carousel" >
      
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/43.jpeg"
          alt="Third slide"
        />
        
      </Carousel.Item>

       <Carousel.Item>
        <img
          className="d-block w-100"
          src="./images/46.jpeg"
          alt="Third slide"
        />
        
      </Carousel.Item>


    </Carousel>
  );
}

export default PadestrianRollerCarousel;